/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Task_Invalid_Waiting_StatusInputs */

const en_api_error_task_invalid_waiting_status = /** @type {(inputs: Api_Error_Task_Invalid_Waiting_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This waiting status is not available for this activity.`)
};

const pt_br2_api_error_task_invalid_waiting_status = /** @type {(inputs: Api_Error_Task_Invalid_Waiting_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este motivo de espera não está disponível para esta atividade.`)
};

/**
* | output |
* | --- |
* | "This waiting status is not available for this activity." |
*
* @param {Api_Error_Task_Invalid_Waiting_StatusInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_task_invalid_waiting_status = /** @type {((inputs?: Api_Error_Task_Invalid_Waiting_StatusInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Task_Invalid_Waiting_StatusInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_task_invalid_waiting_status(inputs)
	return pt_br2_api_error_task_invalid_waiting_status(inputs)
});